import React from 'react'
import logo from '../img/killBeanAi01B.jpg';
import { Link } from 'react-scroll';

const Header = () => {
    return (
        <div className="py-6 full" id='header'>
            <div className="container mx-auto">
                <div className="flex justify-between items-center">
                    <h1 className="sr-only">Philippe Bolduc — Développeur Full-Stack</h1>

                    <a
                        href="#contact"
                        className="inline-block rounded-2xl border border-[#F5981D] px-5 py-2 font-medium text-[#F5981D] hover:bg-[#F5981D] hover:text-black transition"
                    >
                        Contactez-moi
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Header;







